import { useNavigate } from 'react-router-dom';

import { BeneficiaryListRouter } from '@flows/private/beneficiaries/pages/BeneficiaryList/router';
import { MovimentationStepRouter } from '@flows/private/movements/pages/MovimentationSteps/router';
import { BillListRouter } from '@flows/private/financial/pages/List/router';
import { MOVIMENTATION_STEPS_KEYS } from 'constants/private/movements/newMovementSteps';

import QuickActionButton from '../QuickActionButton';
import { StackContainer } from './styles';

export function HomeQuickActionsMobile() {
  const navigate = useNavigate();

  const handleGoToBeneficiaries = () => {
    navigate(BeneficiaryListRouter?.path);
  };

  const handleNewLayoutMovement = () => {
    navigate(
      MovimentationStepRouter.dynamicPath({
        movimentationStep: MOVIMENTATION_STEPS_KEYS?.MOVIMENTATION_FILE,
      }),
    );
  };

  const handleGoToBillList = () => {
    navigate(BillListRouter?.path);
  };

  return (
    <StackContainer direction="row" gap={2}>
      <QuickActionButton
        onClick={handleGoToBeneficiaries}
        text="Lista de beneficiários"
        iconName="actions-b2b-account-multiple"
      />

      <QuickActionButton
        onClick={handleNewLayoutMovement}
        text="Movimentação via layout"
        iconName="actions-b2b-swap-vertical-circle"
      />

      <QuickActionButton
        onClick={handleGoToBillList}
        text="Extrato financeiro"
        iconName="actions-b2b-attach-money"
      />
    </StackContainer>
  );
}
